import React from "react";

function Brokerage() {
  return (
    <div className="container">
      <div className="row p-5 mt-5 border-top ">
      <h1 className="text-muted fs-3 m-4">Charges explained</h1>
        <div className="col-6 p-5">
            
            <h3 className="text-muted fs-4">Securities/Commodities transaction tax</h3>
            <p className="text-muted ">
            Tax by the government when transacting on the exchanges. Charged as above on both buy and sell sides when trading equity delivery. Charged only on selling side when trading intraday or on F&O.
            </p>
            <p className="text-muted ">
            When trading at Zerodha, STT/CTT can be a lot more than the brokerage we charge. Important to keep a tab.
            </p>
            <h3 className="text-muted fs-4">Transaction/Turnover Charges</h3>
            <p className="text-muted">
            Charged by exchanges (NSE, BSE, MCX) on the value of your transactions.
            </p>
            <p className="text-muted">
            BSE has revised transaction charges in XC, XD, XT, Z and ZP groups to ₹10,000 per crore w.e.f 01.01.2016. (XC and XD groups have been merged into a new group X w.e.f 01.12.2017)
            </p>
            <p className="text-muted">
            BSE has revised transaction charges in SS and ST groups to ₹1,00,000 per crore of gross turnover.
            </p>
            <p className="text-muted">
            BSE has revised transaction charges for group A, B and other non exclusive scrips (non-exclusive scrips from group E, F, FC, G, GC, W, T) at ₹375 per crore of turnover on flat rate basis w.e.f. December 1, 2022.
            </p>
            <p className="text-muted">
            BSE has revised transaction charges in M, MT, TS and MS groups to ₹275 per crore of gross turnover.
            </p>
            <h3 className="text-muted fs-4">Stamp charges</h3>
            <p className="text-muted">
            Stamp charges by the Government of India as per the Indian Stamp Act of 1899 for transacting in instruments on the stock exchanges and depositories.
            </p>
            <h3 className="text-muted fs-4">NRI brokerage charges</h3>
            <ul>
                <li className="text-muted">₹100 per order for futures and options.</li>
                <li className="text-muted">For a non-PIS account, 0.5% or ₹100 per executed order for equity (whichever is lower).</li>
                <li className="text-muted">For a PIS account, 0.5% or ₹200 per executed order for equity (whichever is lower).</li>
                <li className="text-muted">₹500 + GST as yearly account maintenance charges (AMC) charges.</li>
            </ul>
            <h3 className="text-muted fs-4">Account with debit balance</h3>
            <p className="text-muted">
            If the account is in debit balance, any order placed will be charged ₹40 per executed order instead of ₹20 per executed order.  
            </p>
            <h3 className="text-muted fs-4">Charges for Investor's Protection Fund Trust (IPFT) by NSE</h3>
            <ul>
                <li className="text-muted">Equity and Futures - ₹10 per crore + GST of the traded value.</li>
                <li className="text-muted">Options - ₹50 per crore + GST traded value (premium value).</li>
                <li className="text-muted">Currency - ₹0.05 per lakh + GST of turnover for Futures and ₹2 per lakh + GST of premium for Options.</li>
            </ul>
            <h3 className="text-muted fs-4">Margin Trading Facility (MTF)</h3>
            <ul>
                <li className="text-muted">MTF Interest: 0.04% per day (₹40 per lakh) on the funded amount. The interest is applied from T+1 day until the day MTF stocks are sold.</li>
                <li className="text-muted">MTF Brokerage: 0.3% or Rs. 20/executed order, whichever is lower.</li>
                <li className="text-muted">MTF pledge charge: ₹30 + GST per pledge request per ISIN.</li>
            </ul>

        </div>
        <div className="col-6 p-5">
            <h3 className="text-muted fs-4">GST</h3>
            <p className="text-muted">Tax levied by the government on the services rendered. 18% of ( brokerage + SEBI charges + transaction charges)</p>
            <h3 className="text-muted fs-4">SEBI Charges</h3>
            <p className="text-muted">Charged at ₹10 per crore + GST by Securities and Exchange Board of India for regulating the markets.</p>
            <h3 className="text-muted fs-4">DP (Depository participant) charges</h3>
            <p className="text-muted">₹15.34 per scrip (₹3.5 CDSL fee + ₹9.5 Zerodha fee + ₹2.34 GST) is charged on the trading account ledger when stocks are sold, irrespective of quantity.</p>
            <p className="text-muted">Female demat account holders (as first holder) will enjoy a discount of ₹0.25 per transaction on the CDSL fee.</p>
            <p className="text-muted">Debit transactions of mutual funds & bonds get an additional discount of ₹0.25 on the CDSL fee.</p>
            <h3 className="text-muted fs-4">Pledging charges</h3>
            <p className="text-muted">For BSDA demat account: Zero charges if the holding value is less than ₹4,00,000. To learn more about BSDA, Click here</p>
            <p className="text-muted">For non-BSDA demat accounts: ₹300/year + 18% GST charged quarterly (90 days). To learn more about AMC, Click here</p>
            <h3 className="text-muted fs-4">Corporate action order charges</h3>
            <p className="text-muted">₹20 plus GST will be charged for OFS / buyback / takeover / delisting orders placed through Console.</p>
            <h3 className="text-muted fs-4">Off-market transfer charges</h3>
            <p className="text-muted">₹25 per transaction.</p>
            <h3 className="text-muted fs-4">Physical CMR request</h3>
            <p className="text-muted">First CMR request is free. ₹20 + ₹100 (courier charge) + 18% GST for subsequent requests.</p>
            <h3 className="text-muted fs-4">Payment gateway charges</h3>
            <p className="text-muted">₹9 + GST (Not levied on transfers done via UPI)</p>
            <h3 className="text-muted fs-4">Delayed Payment Charges</h3>
            <p className="text-muted">Interest is levied at 18% a year or 0.05% per day on the debit balance in your trading account. Learn more.</p>
            <h3 className="text-muted fs-4">Trading using 3-in-1 account with block functionality</h3>
            <ul>
                <li className="text-muted">Delivery & MTF Brokerage: 0.5% per executed order.</li>
                <li className="text-muted">Intraday Brokerage: 0.05% per executed order.</li>

            </ul>
        </div>
      </div>
      
    </div>
  );
}

export default Brokerage;
